export default __webpack_public_path__ + "704b1c1acbb915c81e39a1134144310c.png";